const languages: Record<string, { label: string; flag: string }> = {
  sp: {
    label: "Español",
    flag: "🇪🇸",
  },
  en: {
    label: "English",
    flag: "🇺🇸",
  },
  pt: {
    label: "Português (BR)",
    flag: "🇧🇷",
  },
};

export default languages;
